<script>
import ClubMemberAccessMediumIntraKeyRepository from '../../js/repository/ClubMemberAccessMediumIntraKeyRepository';
import DataProvider from './DataProvider.vue';

export default {
    components: {
        'kgr-data-provider': DataProvider,
    },
    props: {
        memberId: {
            type: Number,
            required: true,
        },
    },
    render(createElement) {
        return createElement(DataProvider, {
            props: {
                repository: ClubMemberAccessMediumIntraKeyRepository.find,
                params: [this.memberId],
                reload: this.load,
            },
            scopedSlots: this.$scopedSlots,
        });
    },
};
</script>
